import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MatchProcessState {
    processingIds: string[];
}

const initialState: MatchProcessState = {
    processingIds: [],
};

export const matchProcessSlice = createSlice({
    name: 'matchProcess',
    initialState,
    reducers: {
        startMatchProcessing(state, action: PayloadAction<{ candidateId: string; offerId: string }>) {
            const key = `${action.payload.candidateId}|${action.payload.offerId}`;
            if (!state.processingIds.includes(key)) {
                state.processingIds.push(key);
            }
        },
        stopMatchProcessing(state, action: PayloadAction<{ candidateId: string; offerId: string }>) {
            const key = `${action.payload.candidateId}|${action.payload.offerId}`;
            state.processingIds = state.processingIds.filter(k => k !== key);
        },
    },
});

export const { startMatchProcessing, stopMatchProcessing } = matchProcessSlice.actions;
export default matchProcessSlice.reducer;